import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import { CustomButton } from "@/shared/components";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export interface ViewColumnsButtonProps {
  columns: any[];
  visibleColumns: number[];
  setVisibleColumns: (cols: number[]) => void;
  [key: string]: any;
}

export const ViewColumnsButton: React.FC<ViewColumnsButtonProps> = ({
  columns = [],
  visibleColumns,
  setVisibleColumns,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <CustomButton
        icon={ViewColumnIcon}
        text="View Columns"
        onClick={handleClick}
        {...props}
      />
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {columns.map((column, index) => {
          if (column?.options?.display === false) return null;
          const selected = visibleColumns.includes(index);
          const onClick = () => {
            if (selected) {
              setVisibleColumns(visibleColumns.filter((i) => i !== index));
            } else {
              setVisibleColumns([...visibleColumns, index]);
            }
          };
          return (
            <MenuItem key={index} onClick={onClick} selected={selected}>
              <ListItemIcon>
                {selected ? (
                  <VisibilityIcon />
                ) : (
                  <VisibilityOffIcon color="disabled" />
                )}
              </ListItemIcon>
              {column.name}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
